export default __webpack_public_path__ + "static/media/icon-users.0201bac8.svg";